import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { Farm } from '../../../store/entities/farms/farms.types';
import { APIManagerConfig } from '../apiManager';

const FarmsServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getFarmsList: (): Promise<any> => HTTPBase.get('farms').then((res) => res.data),
    getFarm: (id: number): Promise<any> => HTTPBase.get(`farms/${id}`).then((res) => res.data),
    updateFarm: (data: Partial<Farm>, formName: FormName): Promise<Farm> =>
      HTTPBase.patch(`farms/${config.farmId}`, data, { headers: { formName } }).then((res) => res.data),
    checkShares: () => HTTPBase.post(`user/shares/check`).then((res) => res.data),
    resetFarm: () => HTTPBase.post(`farm/${config.farmId}/cleardata?initialize=true`),
    getCompanies: (): Promise<any[]> => HTTPBase.get(`companies`).then((res) => res.data),
  };
};

export default FarmsServiceFactory;
